export default {
  VISIBLE_DOMAINS: 5,
  MAX_DOMAINS_COUNT: 50,
};
